/**
 * These helpers do little bits to help change the UI
 */

export function toggleElementVisibility(selector, makeVisible = true, visibilityClass = 'd-flex') {
    $(selector).toggleClass(visibilityClass ?? 'd-flex', makeVisible).toggleClass('d-none', !makeVisible);
}
